// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: BlxA_E123Ds
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicTransparentDisplay.module.css"; // plasmic-import: BlxA_E123Ds/css

export type PlasmicTransparentDisplay__VariantMembers = {
  showLevel: "showLevel";
  showSpace: "showSpace";
};

export type PlasmicTransparentDisplay__VariantsArgs = {
  showLevel?: SingleBooleanChoiceArg<"showLevel">;
  showSpace?: SingleBooleanChoiceArg<"showSpace">;
};

type VariantPropType = keyof PlasmicTransparentDisplay__VariantsArgs;
export const PlasmicTransparentDisplay__VariantProps =
  new Array<VariantPropType>("showLevel", "showSpace");

export type PlasmicTransparentDisplay__ArgsType = {
  children?: React.ReactNode;
};

type ArgPropType = keyof PlasmicTransparentDisplay__ArgsType;
export const PlasmicTransparentDisplay__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicTransparentDisplay__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultTransparentDisplayProps {
  children?: React.ReactNode;
  showLevel?: SingleBooleanChoiceArg<"showLevel">;
  showSpace?: SingleBooleanChoiceArg<"showSpace">;
  className?: string;
}

function PlasmicTransparentDisplay__RenderFunc(props: {
  variants: PlasmicTransparentDisplay__VariantsArgs;
  args: PlasmicTransparentDisplay__ArgsType;
  overrides: PlasmicTransparentDisplay__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    (
      hasVariant(variants, "showSpace", "showSpace")
        ? true
        : hasVariant(variants, "showLevel", "showLevel")
        ? true
        : true
    ) ? (
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          sty.root,
          {
            [sty.rootshowLevel]: hasVariant(variants, "showLevel", "showLevel"),
            [sty.rootshowSpace]: hasVariant(variants, "showSpace", "showSpace")
          }
        )}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "First Floor",
            value: args.children
          })}
        </div>
      </div>
    ) : null
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTransparentDisplay__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTransparentDisplay__VariantsArgs;
    args?: PlasmicTransparentDisplay__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicTransparentDisplay__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicTransparentDisplay__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicTransparentDisplay__ArgProps,
          internalVariantPropNames: PlasmicTransparentDisplay__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicTransparentDisplay__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTransparentDisplay";
  } else {
    func.displayName = `PlasmicTransparentDisplay.${nodeName}`;
  }
  return func;
}

export const PlasmicTransparentDisplay = Object.assign(
  // Top-level PlasmicTransparentDisplay renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicTransparentDisplay
    internalVariantProps: PlasmicTransparentDisplay__VariantProps,
    internalArgProps: PlasmicTransparentDisplay__ArgProps
  }
);

export default PlasmicTransparentDisplay;
/* prettier-ignore-end */
